const RESERVED_TENANT_HOSTS = new Set(['www', 'api', 'admin']);
const PLATFORM_ROOT_HOSTS = new Set([
  'playemp.vip',
  'www.playemp.vip',
  'localhost',
  '127.0.0.1',
  '0.0.0.0',
]);
const RESERVED_ROOT_SEGMENTS = new Set([
  'auth', 'admin', 'app', 'api', 'icons', 'static', 'staff', 'preview',
  'staff-portal', 'finance', 'survey', 'deposit-return', 'download-app', 'portal', 'uploads',
  '__tenant', '__tenant-preview',
]);

function isCustomTenantHost(host) {
  if (!host || PLATFORM_ROOT_HOSTS.has(host)) return false;
  if (/^\d{1,3}(?:\.\d{1,3}){3}$/.test(host)) return false;
  if (host.endsWith('.local')) return false;
  return host.includes('.');
}

export function tenantSlugFromHost(hostname = window.location.hostname) {
  const host = String(hostname || '').split(':')[0].trim().toLowerCase().replace(/\.$/, '');
  if (!host) return null;

  const parts = host.split('.').filter(Boolean);
  if (parts.length >= 3 && parts.slice(-2).join('.') === 'playemp.vip') {
    const subdomain = parts[0].toLowerCase();
    return RESERVED_TENANT_HOSTS.has(subdomain) ? null : subdomain;
  }
  if (isCustomTenantHost(host)) return host;
  return null;
}

export function tenantSlugFromPathOrHost(
  pathname = window.location.pathname,
  hostname = window.location.hostname,
) {
  // A tenant-owned host is authoritative. Old/prefixed links must not turn
  // a route segment into another theme identity or another session scope.
  const hostTenant = tenantSlugFromHost(hostname);
  if (hostTenant) return hostTenant;
  const parts = String(pathname || '').split('/').filter(Boolean);
  if (parts.length > 0) {
    const first = parts[0].toLowerCase();
    if (!RESERVED_ROOT_SEGMENTS.has(first)) return first;
  }
  return null;
}

export function isReservedTenantSegment(segment) {
  const value = String(segment || '').trim().toLowerCase();
  return !value || RESERVED_ROOT_SEGMENTS.has(value);
}
